import { redirect } from "@tanstack/react-router";

export class RouteHelper {
    static AuthGuard(route: { location: { href: string }; context: { isAuthenticated: boolean } }) {
        if (!route.context.isAuthenticated) {
            throw redirect({ to: "/account/login", search: { returnUrl: route.location.href } });
        }
    }

    static AdminAuthGuard(route: {
        location: { href: string };
        context: { isAuthenticated: boolean; isAdmin: boolean };
    }) {
        if (!route.context.isAuthenticated || !route.context.isAdmin) {
            throw redirect({ to: "/account/login", search: { returnUrl: route.location.href } });
        }
    }

    static ManagerAuthGuard(route: {
        location: { href: string };
        context: {
            isAuthenticated: boolean;
            isManager: boolean;
            isAdmin: boolean;
        };
    }) {
        if (!route.context.isAuthenticated || (!route.context.isManager && !route.context.isAdmin)) {
            throw redirect({ to: "/account/login", search: { returnUrl: route.location.href } });
        }
    }
}
